var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgUserData = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 11,
    viewBox: "0 0 12 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_27_1589)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11 0.6875H1C0.447917 0.6875 0 1.14941 0 1.71875V9.28125C0 9.85059 0.447917 10.3125 1 10.3125H11C11.5521 10.3125 12 9.85059 12 9.28125V1.71875C12 1.14941 11.5521 0.6875 11 0.6875ZM11 9.28125H6.31667C6.33542 9.18457 6.33333 9.35859 6.33333 8.8C6.33333 8.1168 5.70625 7.5625 4.93333 7.5625C4.70833 7.5625 4.54375 7.73438 4 7.73438C3.43958 7.73438 3.30417 7.5625 3.06667 7.5625C2.29375 7.5625 1.66667 8.1168 1.66667 8.8C1.66667 9.35859 1.6625 9.18457 1.68333 9.28125H1V3.09375H11V9.28125ZM7.5 7.5625H9.83333C9.925 7.5625 10 7.48516 10 7.39062V7.04688C10 6.95234 9.925 6.875 9.83333 6.875H7.5C7.40833 6.875 7.33333 6.95234 7.33333 7.04688V7.39062C7.33333 7.48516 7.40833 7.5625 7.5 7.5625ZM7.5 6.1875H9.83333C9.925 6.1875 10 6.11016 10 6.01562V5.67188C10 5.57734 9.925 5.5 9.83333 5.5H7.5C7.40833 5.5 7.33333 5.57734 7.33333 5.67188V6.01562C7.33333 6.11016 7.40833 6.1875 7.5 6.1875ZM7.5 4.8125H9.83333C9.925 4.8125 10 4.73516 10 4.64062V4.29688C10 4.20234 9.925 4.125 9.83333 4.125H7.5C7.40833 4.125 7.33333 4.20234 7.33333 4.29688V4.64062C7.33333 4.73516 7.40833 4.8125 7.5 4.8125ZM4 6.875C4.73542 6.875 5.33333 6.2584 5.33333 5.5C5.33333 4.7416 4.73542 4.125 4 4.125C3.26458 4.125 2.66667 4.7416 2.66667 5.5C2.66667 6.2584 3.26458 6.875 4 6.875Z",
    fill: "#FFF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_27_1589"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 11,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgUserData);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/UserData.54371409a4f759b5bef2bdc3d20f1e4a.svg";